import { render } from "./Language.vue?vue&type=template&id=0fe0680b&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=0fe0680b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0fe0680b"

export default script